export const isSupportEmail = (email: string) =>
  email.endsWith('@bettermode.com') || email.endsWith('@tribe.so')
